// VM template definitions — PRODUCT-85.
// Canonical pre-populated defaults used by the VM Form (Step 3) and tested by PRODUCT-96.
// Each template is Omit<VMConfig, 'id' | 'applicationId'> — id and applicationId are
// assigned when the user instantiates a VM from a template.

import type { VMConfig } from '../../types';

export type VMTemplate = Omit<VMConfig, 'id' | 'applicationId' | 'tierId'> & { templateName: string };

export const VM_TEMPLATES: VMTemplate[] = [
  {
    templateName: 'HIS Application Server',
    name: 'HIS Application Server',
    quantity: 1,
    vcpu: 8,
    memoryGb: 32,
    diskLocalGb: 0,
    diskSanGb: 200,
    diskNasGb: 0,
    diskSanIops: 3000,
    diskReadWriteRatio: 70,
    networkBandwidthMbps: 1000,
    networkConfig: {
      securityDomain: 'dmz',
      latencySensitivity: 'standard',
      trafficPattern: 'mixed',
      loadBalancing: 'none',
    },
    workloadThreading: 'multi_thread',
    cpuSpeedMinGhz: 2.0,
    environment: 'production',
    siteAssignment: 'both',
  },
  {
    templateName: 'HIS Database Server',
    name: 'HIS Database Server',
    quantity: 1,
    vcpu: 16,
    memoryGb: 64,
    diskLocalGb: 0,
    diskSanGb: 500,
    diskNasGb: 0,
    diskSanIops: 8000,
    diskReadWriteRatio: 60,
    networkBandwidthMbps: 1000,
    networkConfig: {
      securityDomain: 'internal',
      latencySensitivity: 'low_latency',
      trafficPattern: 'east_west',
      loadBalancing: 'none',
    },
    workloadThreading: 'multi_thread',
    cpuSpeedMinGhz: 2.0,
    environment: 'production',
    siteAssignment: 'both',
  },
  {
    templateName: 'PACS Server',
    name: 'PACS Server',
    quantity: 1,
    vcpu: 8,
    memoryGb: 32,
    diskLocalGb: 0,
    diskSanGb: 0,
    diskNasGb: 0,
    diskSanIops: 2000,
    diskReadWriteRatio: 80,
    networkBandwidthMbps: 1000,
    networkConfig: {
      securityDomain: 'internal',
      latencySensitivity: 'standard',
      trafficPattern: 'east_west',
      loadBalancing: 'none',
    },
    workloadThreading: 'multi_thread',
    cpuSpeedMinGhz: 2.0,
    environment: 'production',
    siteAssignment: 'both',
  },
  {
    templateName: 'ERP Application',
    name: 'ERP Application',
    quantity: 1,
    vcpu: 8,
    memoryGb: 32,
    diskLocalGb: 0,
    diskSanGb: 200,
    diskNasGb: 0,
    diskSanIops: 2000,
    diskReadWriteRatio: 70,
    networkBandwidthMbps: 1000,
    networkConfig: {
      securityDomain: 'dmz',
      latencySensitivity: 'standard',
      trafficPattern: 'mixed',
      loadBalancing: 'none',
    },
    workloadThreading: 'multi_thread',
    cpuSpeedMinGhz: 2.0,
    environment: 'production',
    siteAssignment: 'both',
  },
  {
    templateName: 'VDI Desktop',
    name: 'VDI Desktop',
    quantity: 1,
    vcpu: 4,
    memoryGb: 8,
    diskLocalGb: 0,
    diskSanGb: 60,
    diskNasGb: 0,
    diskSanIops: 500,
    diskReadWriteRatio: 75,
    networkBandwidthMbps: 1000,
    networkConfig: {
      securityDomain: 'internal',
      latencySensitivity: 'standard',
      trafficPattern: 'north_south',
      loadBalancing: 'none',
    },
    workloadThreading: 'multi_thread',
    cpuSpeedMinGhz: 2.0,
    environment: 'production',
    siteAssignment: 'both',
  },
  {
    templateName: 'General Application',
    name: 'General Application',
    quantity: 1,
    vcpu: 4,
    memoryGb: 16,
    diskLocalGb: 0,
    diskSanGb: 100,
    diskNasGb: 0,
    diskSanIops: 1000,
    diskReadWriteRatio: 70,
    networkBandwidthMbps: 1000,
    networkConfig: {
      securityDomain: 'internal',
      latencySensitivity: 'standard',
      trafficPattern: 'mixed',
      loadBalancing: 'none',
    },
    workloadThreading: 'multi_thread',
    cpuSpeedMinGhz: 2.0,
    environment: 'production',
    siteAssignment: 'both',
  },
  {
    templateName: 'Dev/Test Instance',
    name: 'Dev/Test Instance',
    quantity: 1,
    vcpu: 2,
    memoryGb: 8,
    diskLocalGb: 0,
    diskSanGb: 50,
    diskNasGb: 0,
    diskSanIops: 300,
    diskReadWriteRatio: 70,
    networkBandwidthMbps: 1000,
    networkConfig: {
      securityDomain: 'internal',
      latencySensitivity: 'standard',
      trafficPattern: 'mixed',
      loadBalancing: 'none',
    },
    workloadThreading: 'multi_thread',
    cpuSpeedMinGhz: 2.0,
    environment: 'development',
    siteAssignment: 'both',
  },
];
